/** Rebuild a full PlayerView from the previous one plus a ViewDelta (client side). */
import type { PlayerView, ViewDelta } from './types';

export function applyViewDelta(prev: PlayerView, d: ViewDelta): PlayerView {
  const visible = prev.visible.slice();
  for (let i = 0; i < d.visibleChanges.length; i += 2) visible[d.visibleChanges[i]] = d.visibleChanges[i + 1];
  const owner = prev.owner.slice();
  for (let i = 0; i < d.ownerChanges.length; i += 2) owner[d.ownerChanges[i]] = d.ownerChanges[i + 1];
  const w = d.weather;
  const conditions = prev.weather.conditions.slice();
  for (let i = 0; i < w.conditionChanges.length; i += 2)
    conditions[w.conditionChanges[i]] = w.conditionChanges[i + 1];
  return {
    tick: d.tick,
    faction: prev.faction,
    factions: d.factions,
    me: d.me,
    units: d.units,
    contacts: d.contacts,
    couriers: d.couriers,
    dispatches: d.dispatches,
    battles: d.battles,
    visible,
    owner,
    supply: d.supply ?? prev.supply,
    intercepts: d.intercepts,
    events: d.events,
    victoryClock: d.victoryClock,
    winners: d.winners,
    weather: {
      season: w.season,
      temperature: w.temperature,
      wind: w.wind,
      cells: w.cells,
      forecast: w.forecast ?? prev.weather.forecast,
      conditions,
    },
  };
}
